import type { JSX } from 'react'
export default function HomeIcon ({ className }: { className?: string }): JSX.Element {
  return (
    <svg width='12' height='14' viewBox='0 0 12 14' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <path d='M1 5.2L6 1L11 5.2V11.8C11 12.1183 10.8829 12.4235 10.6746 12.6485C10.4662 12.8736 10.1836 13 9.88889 13H2.11111C1.81643 13 1.53381 12.8736 1.32544 12.6485C1.11706 12.4235 1 12.1183 1 11.8V5.2Z' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M4.33301 13V7H7.66634V13' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}
